import { TmsType } from 'app/constants/tmsType'

export const getTmsType = (type) => {
  let tmsType = TmsType.Both

  switch (type) {
    case 0:
      tmsType = TmsType.Loading
      break
    case 1:
      tmsType = TmsType.Unloading
      break
  }

  return tmsType
}
